import React from 'react'
import AsyncSelect from 'react-select/async'
import Slider from '@peracto/peracto-editor-ui/dist/Slider'
import Checkbox from '@peracto/peracto-editor-ui/dist/Checkbox'
import debounce from 'debounce-promise'
import { useConfig } from '@peracto/peracto-config'
import axios from 'axios'

const FormForm = ({ onChange, state: { formId, maxWidth = 100, hideTitle = false } }) => {
    const config = useConfig()
    const API_URL = config.get('api')

    const fetchForms = async input => {
        const { data } = await axios.get(
            `${API_URL}/forms?itemsPerPage=1000&label=${input || ''}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            }
        )

        const parsedData = data['hydra:member']

        const values = parsedData.map(form => ({
            label: form.label,
            value: `/forms/${form.id}`,
        }))

        return values
    }

    const debouncedFetchForms = debounce(fetchForms, 200)

    return (
        <>
            <div className="form-group">
                <label>Form</label>
                <AsyncSelect
                    className="!w-full"
                    loadOptions={input => debouncedFetchForms(input)}
                    isSearchable={true}
                    defaultOptions={true}
                    onChange={option => onChange({ formId: option.value })}
                    placeholder="Select a form..."
                    classNamePrefix="peracto-select"
                    noOptionsMessage={({ inputValue }) => {
                        if (inputValue.length > 0) {
                            return `No forms found for '${inputValue}'.`
                        } else {
                            return 'Enter text to begin searching.'
                        }
                    }}
                />
            </div>

            <Slider
                label={`Max Width (${maxWidth}%)`}
                min={10}
                max={100}
                step={10}
                value={maxWidth}
                onChange={e => onChange({ maxWidth: e.target.value })}
            />

            <Checkbox
                label="Hide Form Title"
                checked={hideTitle}
                onChange={e => onChange({ hideTitle: e.target.checked })}
            />
        </>
    )
}

export default FormForm
